/**
 * Function to conditionally negate a given predicate
 * @param predicate
 * @param negate
 */
export function negateIf( predicate: any, negate: boolean ): boolean {
    return negate ? !predicate : !!predicate;
}